import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';

export default function ProgrammingPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס תכנות – איך לבחור נכון',
        metaTitle: 'קורס תכנות – איך לבחור נכון | Kursi',
        slug: "programming",
        subtitle:
          'קורס תכנות טוב נמדד בתוצרים: פרויקטים, משוב, ותיק עבודות. כאן תקבל מבנה ברור כדי לא ליפול על קורס חלש.',
        chips: ['קריירה', 'פרויקטים', 'תיק עבודות', 'צ׳ק-ליסט'],
        chatSeed: 'קורס תכנות',
        sections: [
          {
            id: 'track',
            title: 'בחר מסלול אחד (לא “נלמד הכל”)',
            body:
              'Web / דאטה / מובייל / QA / אוטומציות — כל מסלול דורש סט כלים אחר. קורס רציני בנוי סביב יעד.',
            bullets: ['בחר יעד אחד ברור', 'ודא שיש פרויקט שמוכיח יכולת', 'ודא שיש תרגול עם משוב'],
          },
          {
            id: 'practice',
            title: 'מה נחשב תרגול אמיתי',
            body:
              'תרגול אמיתי = משימות שאתה מגיש + פידבק. “צפו בסרטון ועשו לבד” לא מספיק לרוב האנשים.',
            bullets: ['בדיקת תרגילים', 'Code review / משוב', 'פרויקט גמר אמיתי'],
          },
          {
            id: 'portfolio',
            title: 'תיק עבודות זה המוצר',
            body:
              'תעודה לא מכניסה עבודה. תיק עבודות כן. קורס טוב מייצר לך 2–4 פרויקטים שנראים כמו עבודה אמיתית.',
            bullets: ['GitHub מסודר', 'פרויקטים עם README', 'הסבר החלטות (לא רק קוד)'],
          },
        ],
        checklist: [
          'יש פרויקטים אמיתיים (לא רק דוגמאות)',
          'יש בדיקת תרגילים / מענה מסודר',
          'יש סילבוס שבועי ברור',
          'יש מסלול למתחילים + איך מתקדמים',
          'יש הכוונה לתיק עבודות / GitHub',
          'יש מדיניות ביטול/החזר הוגנת',
        ],
        redFlags: [
          '“עבודה מובטחת תוך X שבועות”',
          'אין דוגמאות לתוצרי בוגרים',
          'אין תמיכה מסודרת (רק קבוצה בלי מענה)',
          'הכל כללי מדי בלי יעד ברור',
        ],
        faq: [
          { q: 'איזה שפה להתחיל?', a: 'Web → JavaScript/TypeScript, דאטה → Python, מובייל → React Native/Flutter. העיקר: תרגול.' },
          { q: 'בוטקאמפ או קורס?', a: 'בוטקאמפ אינטנסיבי למסגרת מלאה. קורס אם צריך גמישות. תבחר לפי זמן התמדה.' },
        ],
      }}
    />
  );
}
